<body class="building-scan">
  <!-- Table header -->
  <app-table-header
    [headerText]="CONSTS.HEADER"
    [hasAddItem]="false"
    [hasRadioButton]="true"
    [radioHeader]="CONSTS.SELECT"
    [firstOptionValue]="FILTER_IDS.SITE"
    [firstOptionName]="CONSTS.SITE"
    [secondOptionValue]="FILTER_IDS.GROUP"
    [secondOptionName]="CONSTS.GROUP"
    [radioModel]="selectedFilter"
    [filterDisabled]="!isFilterEnabled"
    [rightPadding]="10"
    [hasCollapsedPadding]="false"
    (exportRadioButtonChange)="radioGroupValue($event)"
    (clearFilterEvent)="clearAllFilters()"
    (exportExcelEvent)="exportExcel()"
  >
  </app-table-header>

  <section class="building-scan-mobile" aria-label="mobile-building-scan">
    <div class="mobile-controls-row">
      <div class="search-type-wrapper">
        <label for="search-type" class="mobile-label">{{ CONSTS.SEARCH_TYPE }}</label>
        <select
          id="search-type"
          class="search-type-select"
          [(ngModel)]="selectedFilter"
          (change)="searchTypeChange()"
        >
          <option [value]="FILTER_IDS.SITE">{{ CONSTS.SITE }}</option>
          <option [value]="FILTER_IDS.GROUP">{{ CONSTS.GROUP }}</option>
        </select>
      </div>

      <div class="mobile-action-icons">
        <button
          type="button"
          class="filter-toggle"
          (click)="toggleMobileFilters()"
          [attr.aria-expanded]="showMobileFilters"
          aria-controls="mobile-filter-panel"
          aria-label="filter"
        >
          <img alt="filter" [src]="IMAGES.FILTER_ACTIVE" />
          @if (activeFilterCount > 0) {
            <span class="filter-count">{{ activeFilterCount }}</span>
          }
        </button>

         <button
          type="button"
          class="export-toggle"
          (click)="exportExcel()"
          aria-label="export"
        >
          <img alt="export" [src]="IMAGES.EXCEL_ACTIVE" />
        </button>
      </div>
    </div>

    @if (showMobileFilters) {
      <div class="mobile-filter-panel" id="mobile-filter-panel">
        <div class="mobile-filter-title">{{ CONSTS.FILTERS }}</div>
        <div class="mobile-filter-grid">
          <label class="mobile-filter-field">
            <span>{{ CONSTS.DESCRIPTION }}</span>
            <input
              type="text"
              [maxlength]="20"
              [formControl]="descriptionData.formControl"
              (keyup)="search()"
            />
          </label>

          <label class="mobile-filter-field">
            <span>{{ CONSTS.REASON }}</span>
            <input
              type="text"
              [maxlength]="6"
              [formControl]="reasonData.formControl"
              (keyup)="search()"
            />
          </label>

          <label class="mobile-filter-field">
            <span>{{ CONSTS.STATUS }}</span>
            <input
              type="text"
              [maxlength]="6"
              [formControl]="statusData.formControl"
              (keyup)="search()"
            />
          </label>

          <label class="mobile-filter-field">
            <span>{{ CONSTS.RESOLUTION }}</span>
            <input
              type="text"
              [maxlength]="6"
              [formControl]="resolutionData.formControl"
              (keyup)="search()"
            />
          </label>
        </div>

        <div class="mobile-filter-actions">
          <button type="button" class="btn-clear" (click)="clearMobileFilters()">
            {{ CONSTS.CLEAR }}
          </button>
          <button type="button" class="btn-apply" (click)="applyMobileFilters()">
            {{ CONSTS.APPLY }}
          </button>
        </div>
      </div>
    }

    <div class="mobile-cards-wrapper">
      @if (mobileTotalItems > 0) {
        @for (buildingScanTable of mobileVisibleData; track buildingScanTable.description + '-' + $index) {
          <article class="mobile-card">
            <div class="mobile-card-checkbox">
              <ion-checkbox
                class="custom-checkbox-control"
                [(ngModel)]="buildingScanTable.enable"
                (ngModelChange)="checkboxValueChanges(buildingScanTable, buildingScanTable.enable)"
              ></ion-checkbox>
            </div>

            <div class="mobile-card-content">
              <div class="mobile-field">
                <span class="mobile-field-label">{{ CONSTS.DESCRIPTION }}</span>
                <span class="mobile-field-value">{{ buildingScanTable.description || CONSTS.N_A }}</span>
              </div>

              <div class="mobile-field">
                <span class="mobile-field-label">{{ CONSTS.REASON }}</span>
                <span class="mobile-field-value">{{ buildingScanTable.reason || CONSTS.N_A }}</span>
              </div>

              <div class="mobile-field">
                <span class="mobile-field-label">{{ CONSTS.STATUS }}</span>
                <span class="mobile-field-value">{{ buildingScanTable.status || CONSTS.N_A }}</span>
              </div>

              <div class="mobile-field">
                <span class="mobile-field-label">{{ CONSTS.RESOLUTION }}</span>
                <span class="mobile-field-value">{{ buildingScanTable.resolution || CONSTS.N_A }}</span>
              </div>
            </div>
          </article>
        }
      } @else {
        <div class="mobile-no-results">
          <app-no-results-found></app-no-results-found>
        </div>
      }
    </div>
  </section>

  <div class="building-scan-table-container">
    <table mat-table [dataSource]="dataSource" class="building-scan-table">
      <!-- Description -->
      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef>
          <app-table-search-component
            [columnName]="CONSTS.DESCRIPTION"
            [allowedSpecialChars]="SPECIAL_CHARS.SPACE"
            [control]="descriptionData.formControl"
            [maxLength]="20"
            (emitSearch)="search()"
          ></app-table-search-component>
        </th>
        <td
          mat-cell
          *matCellDef="let buildingScanTable"
          headers="description-headers"
          class="left-data-column"
        >
          {{ buildingScanTable.description }}
        </td>
      </ng-container>

      <!-- Reason -->
      <ng-container matColumnDef="reason">
        <th mat-header-cell *matHeaderCellDef>
          <app-table-search-component
            [columnName]="CONSTS.REASON"
            [control]="reasonData.formControl"
            [maxLength]="6"
            (emitSearch)="search()"
          ></app-table-search-component>
        </th>
        <td
          mat-cell
          *matCellDef="let buildingScanTable"
          headers="reason-headers"
          class="left-data-column"
        >
          {{ buildingScanTable.reason }}
        </td>
      </ng-container>

      <!-- Status -->
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>
          <app-table-search-component
            [columnName]="CONSTS.STATUS"
            [control]="statusData.formControl"
            [maxLength]="6"
            (emitSearch)="search()"
          ></app-table-search-component>
        </th>
        <td
          mat-cell
          *matCellDef="let buildingScanTable"
          headers="status-headers"
          class="left-data-column"
        >
          {{ buildingScanTable.status }}
        </td>
      </ng-container>

      <!-- Resolution -->
      <ng-container matColumnDef="resolution">
        <th mat-header-cell *matHeaderCellDef>
          <app-table-search-component
            [columnName]="CONSTS.RESOLUTION"
            [control]="resolutionData.formControl"
            [maxLength]="6"
            (emitSearch)="search()"
          ></app-table-search-component>
        </th>
        <td
          mat-cell
          *matCellDef="let buildingScanTable"
          headers="resolution-headers"
          class="left-data-column"
        >
          {{ buildingScanTable.resolution }}
        </td>
      </ng-container>

      <!-- Enabled -->
      <ng-container matColumnDef="enabled">
        <th mat-header-cell *matHeaderCellDef>
          <ion-row class="th-text center-align">
            {{ CONSTS.ENABLED }}
          </ion-row>
          <ion-row class="search-wrapper">
            <div class="search-header-labels"></div>
          </ion-row>
        </th>
        <td
          mat-cell
          *matCellDef="let buildingScanTable"
          headers="site-headers"
        >
          <ion-checkbox
            class="custom-checkbox-control"
            [(ngModel)]="buildingScanTable.enable"
            (ngModelChange)="checkboxValueChanges(buildingScanTable, buildingScanTable.enable)"
          ></ion-checkbox>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="COLUMNS; sticky: true"></tr>

      <tr mat-row *matRowDef="let row; columns: COLUMNS"></tr>

      <tr class="mat-row no-results" *matNoDataRow>
        <td class="mat-cell no-border" [attr.colspan]="COLUMNS.length">
          <app-no-results-found></app-no-results-found>
        </td>
      </tr>
    </table>
  </div>
  <app-table-pagination
    class="desktop-pagination"
    [datasource]="dataSource"
  ></app-table-pagination>
</body>
